import { render } from "./Inventory_TransferView_Dialog.vue?vue&type=template&id=7613f74f&scoped=true&ts=true"
import script from "./Inventory_TransferView_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_TransferView_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_TransferView_Dialog.vue?vue&type=style&index=0&id=7613f74f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7613f74f"]])

export default __exports__